const TOKEN_KEY = "arena_access_token";

export function getToken(): string | null {
  return ["/atendimento-app","/reservas-app","/aulas-app"].includes(window.location.pathname) ? sessionStorage.getItem("arena_support_token") : localStorage.getItem(TOKEN_KEY);
}

export function setToken(token: string | null): void {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

export class ApiRequestError extends Error {
  constructor(message: string, public readonly status: number, public readonly details?: unknown) {
    super(message);
  }
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const token = getToken();
  const response = await fetch(path, {
    ...init,
    headers: {
      ...(init.body ? { "Content-Type": "application/json" } : {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...init.headers,
    },
  });
  const payload = await response.json().catch(() => ({})) as { message?: string; details?: unknown };
  if (!response.ok) {
    if (response.status === 401 && path !== "/api/auth/login") setToken(null);
    throw new ApiRequestError(payload.message ?? "Nao foi possivel concluir a operacao.", response.status, payload.details);
  }
  return payload as T;
}

export function toCents(value: string): number {
  const normalized = value.replace(/[^0-9,.-]/g, "").replace(",", ".");
  return Math.round(Number(normalized || 0) * 100);
}
